import { msalInstance } from '@/config/msalConfig';

const FALLBACK = 'site-compliance-ui';

/**
 * Returns the principal that should be attributed to mutations the UI performs.
 * Prefers MSAL active account (same pattern as ORR Web). Last resort returns a
 * non-mock label so persisted entities are traceable.
 */
export const getCurrentUserPrincipal = (): string => {
  const account =
    msalInstance.getActiveAccount() ?? msalInstance.getAllAccounts()[0] ?? null;
  if (account?.username) return account.username;

  return FALLBACK;
};
